// import { Modal, notification } from "antd";
// import { getProjectService } from "../../backend";
// import { setProjectLocalStorage } from "../local-storage";

interface IDeployEnvironmentProps {
    // currentProjectId: string,
    // shouldInitiateTrial: boolean,
    // setShouldInitiateTrial: Function,
    // setCurrentProject: Function,
    // updateCurrentProject: Function,
    deployStage: Function
}

// const updateProjectInfo = async (projectId: string, setCurrentProject: Function) => {
//     const { data: project } = await getProjectService().getProject(projectId);
//     setProjectLocalStorage(project);
//     setCurrentProject(project!);
// }


// const upgradeSubscription = async (setCurrentProject: Function, updateCurrentProject: Function, currentProjectId: string) => {
//     const { data: { paymentPlans } } = await getProjectService().getAllPaymentPlans();
//     const starterPlan = paymentPlans.find(plan => plan.id === "STARTER")!;
//     try {
//         await getProjectService().changeProjectSubscription(
//             currentProjectId,
//             {
//                 paymentPlanId: starterPlan.id!,
//                 priceId: starterPlan.pricing.find(p => p.isDefault)!.id
//             }
//         );
//         await updateCurrentProject(currentProjectId);
//     } catch (error) {
//         notification.error({
//             message: "Cannot upgrade subscription",
//             description: (error as any).response.data.message
//         });
//     }
//     await updateProjectInfo(currentProjectId, setCurrentProject);
//     return { done: true };
// }

export const handleDeployEnvironment = async ({
    // currentProjectId,
    // shouldInitiateTrial,
    // setShouldInitiateTrial,
    // setCurrentProject,
    // updateCurrentProject,
    deployStage
}: IDeployEnvironmentProps) => {
    // if (shouldInitiateTrial) {
    //     Modal.confirm({
    //         title: "Starter plan required",
    //         content:
    //             <div>
    //                 Continuing will initiate a 7 day trial of the Starter plan.
    //             </div>,
    //         okText: "Start free trial",
    //         centered: true,
    //         async onOk() {
    //             await upgradeSubscription(setCurrentProject, updateCurrentProject, currentProjectId);
    //             setShouldInitiateTrial(false);
    //             return deployStage();
    //         }
    //     });
    // } else {
    return deployStage();
    // }
}